export const types = {
  CLOSE: 'contacts/accountDetails/facilitiesDrawer/CLOSE',
  OPEN: 'contacts/accountDetails/facilitiesDrawer/OPEN',
};

export const facilitiesDrawer = {
  close: () => ({
    type: types.CLOSE,
  }),
  open: () => ({
    type: types.OPEN,
  }),
};
